import moment from "moment"
import {  formatDateToTime, converToJsonDate } from '../../../../common/timeLiveFunction';

export interface ShiftClass {
  AccountShiftId: string
  Name: string
  Code: string
  Description: string
  StartTime: Date | undefined
  EndTime: Date | undefined
  AccountId: number
  IsDeleted: boolean
  IsDisabled: boolean
  AllowPhotoCapture: boolean | null
  AllowLocationInWeb: boolean | null
  AllowLocationInMobile: boolean | null
  TotalHoursCalculation: string
  DepartmentSelectionInAttendance: boolean | null
  DepartmentSelectionInBreak: boolean | null
  AllowDepartmentInAttendance: boolean | null
  isSelected: number
  Breaks:Array<AccountBreak>
  AllowOvernightShift: boolean | null
  ShiftCutoffTime: Date | undefined
}

export interface AccountBreak {
  AccountBreakId:string
  AccountBreakTypeId: string
  BreakDuration:number
  BreakTime:any
  
}
export const defaultBreak: AccountBreak = {
  AccountBreakId:'00000000-0000-0000-0000-000000000000',
  AccountBreakTypeId: '00000000-0000-0000-0000-000000000000',
  BreakDuration: 0, 
  BreakTime: formatDateToTime(new Date().toISOString()) 
};

const common = {    
  Name: "",
  Code: "",
  Description: "",
  StartTime: moment().format('HH:mm:ss'),
  EndTime: moment().format('HH:mm:ss'),
  AccountId: 0,
  IsDeleted: false,
  IsDisabled: false,
  AllowPhotoCapture: false, 
  AllowLocationInWeb: false, 
  AllowLocationInMobile: false, 
  TotalHoursCalculation: "firstcheckin",
  DepartmentSelectionInAttendance: false, 
  DepartmentSelectionInBreak: false, 
  AllowDepartmentInAttendance: false ,
  Breaks:[defaultBreak],
  AllowOvernightShift: false,
  ShiftCutoffTime: moment().format('HH:mm:ss')
};
export const ShiftInitialsForAdd = { ...common };

export const ShiftInitialsForUpdate = {
  ...common,
  AccountShiftId: 0
};

export const getDefaultBreak =(): AccountBreak =>( {
  AccountBreakId:'00000000-0000-0000-0000-000000000000',
  AccountBreakTypeId: '00000000-0000-0000-0000-000000000000',
  BreakDuration: 0, 
  BreakTime:  '0:00'//formatDateToTime(new Date().toISOString()) 
});